import MutationTypes from "./mutation-types.js";
import ActionTypes from "./action-types";

import API from "@/api/index";

const actions = {};

const GET_AVAILABLE_MQTT_CREDENTIALS = "/Misc/GetAvailableMQTTCredentials";

actions[ActionTypes.FETCH_MQTT_CREDENTIALS] = context => {
	API.fetchJson(
		GET_AVAILABLE_MQTT_CREDENTIALS,
		null,
		// Error callback
		exception => {
			console.error("Exception fetching MQTT credentials", exception);
			return Promise.resolve(null);
		}
	).then(json => {
		context.commit(MutationTypes.SET_MQTT_CREDENTIALS, json);
	});
};

actions[ActionTypes.FETCH_USER_INFO] = context => {
	return API.fetchJson(
		API.ENDPOINTS.GET_USER_INFO,
		null,
		// Error callback
		exception => {
			console.error("Exception fetching user info", exception);
		}
	).then(json => {
		if (!json || !json["ok"] || !json["data"]) {
			context.commit(MutationTypes.SET_USERNAME, "");
			context.commit(MutationTypes.SET_PRIMARY_CLIENT, 0);
			context.commit(MutationTypes.SET_ROLES, []);
			context.commit(MutationTypes.SET_FEATURES, []);
			context.commit(MutationTypes.SET_LABELMAPPINGS, {});
			// TODO: Add Toast with error message here.
			return;
		}

		// TESTING: add ess diagnostics role claim to test auth guard
		// json.data.roles.push("ESSdiagnostics");
		// json.data.roles.sort();

		context.commit(MutationTypes.SET_USERNAME, json.data.username);
		context.commit(MutationTypes.SET_LABELMAPPINGS, json.data.labelMappings);
		context.commit(MutationTypes.SET_ROLES, json.data.roles);
		context.commit(MutationTypes.SET_FEATURES, json.data.features);
		context.commit(MutationTypes.SET_PRIMARY_CLIENT, json.data.primaryClientId);
		context.commit(
			MutationTypes.SET_PROFILE_ATTRIBUTES,
			json.data.profileAttributes
		);
	});
};

// The router will not perform routing until the promise returned by this method fullfills.
// Anything required before routing occurs should be placed here, e.g. the roles the user has.
actions[ActionTypes.INIT] = ({ dispatch }) => {
	return Promise.all([dispatch(ActionTypes.FETCH_USER_INFO)]);
};

export default actions;
